import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import Button from 'components/modules/button/Button';
import Modal from 'components/modules/modal/Modal';
import { RoomInfoItems } from 'constant';

interface ModalMemoProps {
  info: any;
  onClose: (
    isRegister: boolean,
    dLoc: string,
    wCond: string,
    accType: string,
    dType: string,
    dRoute: string,
    prcRslt: string | undefined
  ) => void;
}

interface IRooomResult {
  dLoc: string;
  wCond: string;
  accType: string;
  dType: string;
  dRoute: string;
  prcRslt: string;
}

const ModalUpdate = ({ info, onClose }: ModalMemoProps) => {
  const [isShow, setShow] = useState(false);
  const [roomInfo, setRoomInfo] = useState<IRooomResult>({
    dLoc: '',
    wCond: '',
    accType: '',
    dType: '',
    dRoute: '',
    prcRslt: '',
  });

  const onChangeRslt = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.currentTarget.value;
    setRoomInfo((prev) => {
      return {
        ...prev,
        prcRslt: value,
      };
    });
  };

  const onChangeSelect = (key: string, e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setRoomInfo((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const _Close = () => {
    setShow(false);
    onClose(false, roomInfo.dLoc, roomInfo.wCond, roomInfo.accType, roomInfo.dType, roomInfo.dRoute, undefined);
  };

  const onSave = async () => {
    try {
      setShow(false);
      onClose(true, roomInfo.dLoc, roomInfo.wCond, roomInfo.accType, roomInfo.dType, roomInfo.dRoute, roomInfo.prcRslt);
      setRoomInfo((prev) => {
        return {
          ...prev,
          prcRslt: '',
        };
      });
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (info !== undefined) {
      setShow(info.isUpdate);
      setRoomInfo((prev) => {
        return {
          ...prev,
          dLoc: info.dLoc,
          wCond: info.wCond,
          accType: info.accType,
          dType: info.dType,
          dRoute: info.dRoute,
          prcRslt:
            info.prcRslt === null
              ? new Date().toLocaleTimeString('ko-KR', {
                  hour12: false,
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                }) + ' '
              : info.prcRslt +
                '\n' +
                new Date().toLocaleTimeString('ko-KR', {
                  hour12: false,
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                }) +
                ' ',
        };
      });
    }
  }, [info]);

  return (
    <Modal isOpen={isShow} onClose={() => _Close()}>
      <ModalTemplate>
        <HeaderWrap>
          <HeaderTitle>구조 활동</HeaderTitle>
        </HeaderWrap>

        <RegisterWrapp>
          <Grid>
            {RoomInfoItems.map((item: any, index: number) => (
              <div style={{ display: 'flex' }} key={index}>
                <SelectTitle>{item.title}</SelectTitle>
                <SelectWrap id={item.id} value={roomInfo[item.id]} onChange={(e) => onChangeSelect(item.id, e)}>
                  {item.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </SelectWrap>
              </div>
            ))}
          </Grid>
        </RegisterWrapp>

        <ContentsWrap>
          <LocWrap>
            <SubTitleWrap>구조활동</SubTitleWrap>
            <LocTextArea
              placeholder="구조활동 내용을 입력하세요"
              rows={2}
              value={roomInfo.prcRslt}
              onChange={onChangeRslt}
            />
          </LocWrap>
        </ContentsWrap>

        <FooterWrap>
          <Button title="취소" color="secondary" onClick={() => _Close()} />
          <Button title="저장" onClick={onSave} />
        </FooterWrap>
      </ModalTemplate>
    </Modal>
  );
};

const ModalTemplate = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100%);
  // height: calc(100% - 140px);
  flex-flow: column nowrap;
  background-color: #abc9df;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;
const HeaderWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: #11497e;
  // border-bottom: 2px solid #cccccc;
  border-radius: 10px 10px 0 0;
`;
const HeaderTitle = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  // justify-content: center;
  margin-left: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
`;
const RegisterWrapp = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 30px 0;
  border-radius: 10px;
`;
const ContentsWrap = styled.div`
  padding: 0 10px;
  display: flex;
  flex-flow: column nowrap;
  @media (max-width: 319px) {
    padding: 0 10px;
  }
`;
const LocWrap = styled.div`
  position: relative;
  padding: 0 15px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
`;
const SubTitleWrap = styled.div`
  position: relative;
  padding-right: 10px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;
const LocTextArea = styled.textarea`
  flex: 0 0 auto;
  border-radius: 10px;
  padding: 12px;
  width: 75%;
  min-width: 200px;
  min-height: 200px;
  background-color: #f2f2f2;
  border: 2px solid #dddddd;
  font-size: 16px;
  font-weight: 600;
  resize: none;

  ::placeholder {
    text-align: center;
    color: #000000;
    position: absolute;
    // top: calc(50% - 10px);
    // left: 0;
    // right: 0;
    // bottom: 0;
    line-height: 20px;
  }
`;
const FooterWrap = styled.div`
  padding: 20px;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;

  button {
    margin: 0 5px;
    border-radius: 10px;
    min-height: 40px;
    max-width: 140px;
    cursor: pointer;
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px 3px;
`;
const SelectTitle = styled.div`
  display: flex;
  width: 100px;
  height: 44px;
  align-items: center;
  justify-content: center;
  background: #11497e;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  flex-shrink: 0;
  border-top-left-radius: 5px;
  // border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  // border-bottom-right-radius: 5px;
`;
const SelectWrap = styled.select`
  width: 100%;
  height: 44px;
  border: none;
  font-size: 16px;
  background: #f7fafd;
  padding-left: 12px;
  flex-grow: 1;
  border-top-right-radius: 5px;
  // border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export default ModalUpdate;
